import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {connect} from "react-redux";
import FeatureWizardBodyItem from "./featureWizardBodyItem";
import FeatureWizardSelection from "./featureWizardSelection";
import {s3FilterImagePath} from "../../../../misc/utils";

class FeatureWizardBody extends Component {

  static propTypes = {
    currentStep: PropTypes.object.isRequired,
    activeSubPart: PropTypes.object.isRequired,
    filterGroups: PropTypes.array.isRequired,
    features: PropTypes.array,
    onItemClick: PropTypes.func.isRequired,
    onItemClickDisabled: PropTypes.func.isRequired,
    availableSteps: PropTypes.array,
    featureWizardStep: PropTypes.number,
    isPhoneNumberValidated: PropTypes.bool,
    isMobile: PropTypes.bool,
    handleUserLoginClick: PropTypes.func,
    setFeatureWizardStep: PropTypes.func,
    showerWallWizardGroupsSelected: PropTypes.bool,
    searchText: PropTypes.string,
  };

  constructor(props) {
    super(props);
    this.state = {
      currentValues: []
    }
  }

  componentDidMount() {
   this.setCurrentValues();
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.currentStep && this.props.currentStep && (nextProps.currentStep.id !== this.props.currentStep.id)) {
      this.setCurrentValues(nextProps);
    }
  }

  setCurrentValues(nextProps = this.props) {
    const currentGroup = nextProps.filterGroups.find((filterGroup) => {
      return filterGroup.id === nextProps.currentStep.id
    });
    const fabricatorSettings = this.props.fabricatorSettings;
    const filteredFeatures = nextProps.features.filter(feature => {
      return !feature.dbFeature.displayName.includes("laceholder")
    });
    const selectedId = nextProps.currentStep.selectedValueId;
    const currentValues = nextProps.currentStep.values
      .map((wizardValueObject) => {
        const currentFilterValue = this.getFilterValueObjectById(currentGroup, wizardValueObject.filterValue);
        const itemIsLocked = this.getLockedPropertyValueObjectById(currentFilterValue, filteredFeatures, wizardValueObject.filterValue, fabricatorSettings, nextProps);
        wizardValueObject.itemIsLocked = itemIsLocked;
        // console.log('wizardValueObject', wizardValueObject);
        return wizardValueObject
      })
      .sort((a,b) => {
        const selectedA = selectedId === a.filterValue;
        const selectedB = selectedId === b.filterValue;
        if (selectedA < selectedB) {
          return 1
        } else if (selectedB < selectedA) {
          return - 1
        } else {
          if (a.selectionAvailable < b.selectionAvailable) {
            return 1
          } else if (b.selectionAvailable < a.selectionAvailable) {
            return - 1
          } else {
            return (a.itemIsLocked > b.itemIsLocked) ? 1 : ((b.itemIsLocked > a.itemIsLocked) ? -1 : 0)
          }
        }
      });
    this.setState({
      currentValues
    })
  }

  getFilterValueObjectById = (currentGroup, filterValueId) => {
    return currentGroup.values.find(currentGroupValue => {
      return currentGroupValue.id === filterValueId
    });
  };

  getLockedPropertyValueObjectById = (currentFilterValue, filteredFeatures, filterValueId, fabricatorSettings, nextProps = this.props) => {

    const {isBackend, jobId, canSaveQuote, visualizerManagement} = document.kvConfig;

    if (!fabricatorSettings.leadCapture
      || (fabricatorSettings.leadCapture && visualizerManagement)
      || (fabricatorSettings.leadCapture && nextProps.isPhoneNumberValidated)
      || (fabricatorSettings.leadCapture && (isBackend && jobId && canSaveQuote))){
      return false
    }

    return currentFilterValue.lockedInWizard || !filteredFeatures.some(feature => {
      // console.log('bject.keys(feature.dbFeature.filterValueIDs)', Object.keys(feature.dbFeature.filterValueIDs));
      const filterToFind = feature.dbFeature.filterValueIDs[nextProps.currentStep.id];
      return filterToFind && filterToFind.includes(filterValueId) && feature.dbFeature.unlocked;
    })
  };

  getFeatureBodyItemThumbnail = (currentFilterValue) => {
    const additionalImages = currentFilterValue.additionalImages;
    if (Array.isArray(additionalImages) && additionalImages.length) {
      // console.log('props.currentFilterValue', currentFilterValue);
      if (this.props.activeSubPart.partId === "vanity_cabinet" && this.props.currentStep.filterName === "Color") {
        const materialFilter = this.props.availableSteps.find(step => step.filterName === "Material");
        if (materialFilter && materialFilter.selectedValueId) {
          const neededImage = additionalImages.find(image => image.filterValueIds.includes(materialFilter.selectedValueId));
          if (neededImage && neededImage.imageUrl) {
            return neededImage.imageUrl
          }
          return additionalImages[0].imageUrl
        }
      }
      return additionalImages[0].imageUrl
    }
    return s3FilterImagePath(currentFilterValue.icon);
  };

  getFeatureWizardBodyItem = (currentFilterValue, currentGroup, wizardValueObject, filteredFeatures, fabricatorSettings, key) => {

    // const thumbNailPath = `${basePath}images/thumbnails/${parentGroup}/${props.isMobile ? "100" : "400"}/${featureName}.JPG`;
    // console.log('thumbNailPath', thumbNailPath);

    /*** image ***/
    const styles = {
      backgroundImage: "url(" + this.getFeatureBodyItemThumbnail(currentFilterValue) + ")"
    };
    const bgFilterName = this.props.currentStep.filterName.replace(/ /g,"");
    const bgFilterNameFilters = ["Material", "Color", "TilePattern", "AcrylicPattern", "AcrylicColor"];
    const backGroundSizeCover = bgFilterNameFilters.includes(bgFilterName);

    // const parentGroup = props.currentStep.filterName.replace(/ /g,"");
    // let featureName = props.currentFilterValue.displayText.replace(/ /g,"");
    // if (parentGroup === "Color") {
    //   const woodType = props.availableSteps.find(step => step.filterName === "Material");
    //   featureName = woodType.selectedValueName.replace(/ /g,"") + "_" + featureName;
    //   if (featureName === "Alder_Eggshell" || featureName === "Alder_Graphite" || featureName === "Alder_White" // temporary hardcode until we have BE for multi thumbnails ready
    //     || featureName === "Oak_Eggshell" || featureName === "Oak_Graphite" || featureName === "Oak_White") {
    //     featureName = "custom/" + featureName;
    //   }
    // }

    /*** active ***/
    const isActive = currentFilterValue && (this.props.currentStep.selectedValueId === currentFilterValue.id);

    /*** locked ***/
    const itemIsLocked = this.getLockedPropertyValueObjectById(currentFilterValue, filteredFeatures, wizardValueObject.filterValue, fabricatorSettings);

    /*** pulsating ***/
    let isPulsating = false;
    if ((fabricatorSettings.leadCapture && !(document.kvConfig.isBackend && document.kvConfig.jobId && document.kvConfig.canSaveQuote)) && !this.props.isPhoneNumberValidated
      && !itemIsLocked) {
      if (!this.props.currentStep.selectedValueId) {
        isPulsating = true
      } else {
        const selectedFilterValue = this.getFilterValueObjectById(currentGroup, this.props.currentStep.selectedValueId);
        const selectedItemIsLocked = this.getLockedPropertyValueObjectById(selectedFilterValue, filteredFeatures, this.props.currentStep.selectedValueId, fabricatorSettings);
        if (selectedItemIsLocked) {
          isPulsating = true
        }
      }
    }

    /*** disabled ***/
    let disabled = (this.props.featureWizardStep === 0) ? false : !wizardValueObject.selectionAvailable;

    const getQuoteEnabled = fabricatorSettings.enableQuote;

    return (
      <FeatureWizardBodyItem currentFilterValue={currentFilterValue}
                             currentStep={this.props.currentStep}
                             onItemClick={this.props.onItemClick}
                             onItemClickDisabled={this.props.onItemClickDisabled}
                             isActive={isActive}
                             itemIsLocked={itemIsLocked}
                             isPulsating={isPulsating}
                             getQuoteEnabled={getQuoteEnabled}
                             userIsLoggedIn={this.props.userIsLoggedIn}
                             availableSteps={this.props.availableSteps}
                             featureWizardStep={this.props.featureWizardStep}
                             disabled={disabled}
                             handleUserLoginClick={this.props.handleUserLoginClick}
                             isMobile={this.props.isMobile}
                             key={key}
                             styles={styles}
                             backGroundSizeCover={backGroundSizeCover}
      />
    )

  };

  renderItemsList = (currentGroup, filteredFeatures, values, fabricatorSettings) => {
    const navigationViewType = this.props.navigationViewType === 3 ? 2 : 1;

    const elements = [];

    for (let i = 0; i < Math.ceil(values.length / navigationViewType); i++ ) {  // for ex. 28/3 = 10 columns
      const innerElements = [];
      for (let j = 0; j < navigationViewType;j++ ) {

        const currentIndex = j+(i*navigationViewType);
        const wizardValueObject = values[currentIndex];

        if (!wizardValueObject) {
          innerElements.push(
            <div className="feature feature--empty" key={"item"+j+i}/>
          );
        } else {
          const currentFilterValue = this.getFilterValueObjectById(currentGroup, wizardValueObject.filterValue);
          innerElements.push(this.getFeatureWizardBodyItem(
              currentFilterValue,
              currentGroup,
              wizardValueObject,
              filteredFeatures,
              fabricatorSettings,
              "item"+j+i
            )
          );
        }
      }
      elements.push(
        <li className="features-list__item" key={"features-list__item"+i}>
          {innerElements}
        </li>
      );
    }
    // console.log('elements', elements);
    return elements
  };

  render() {
    // console.log('currentStep', this.props.currentStep);
    const currentGroup = this.props.filterGroups.find((filterGroup) => {
      return filterGroup.id === this.props.currentStep.id
    });
    const filteredFeatures = this.props.features.filter(feature => {
      return !feature.dbFeature.displayName.includes("laceholder");
    });
    const fabricatorSettings = this.props.fabricatorSettings;

    const interiorShowerWallWizard = this.props.activeSubPart.partId === "shower_interior_wall";
    if (interiorShowerWallWizard && !this.props.showerWallWizardGroupsSelected) {
      return (
        <FeatureWizardSelection
          currentStep={this.props.currentStep}
          toggleWizardFilterSelection={this.props.toggleWizardFilterSelection}
          onItemClick={this.props.onItemClick}
          getFilterValueObjectById={this.getFilterValueObjectById}
          exitFeatureWizard={this.props.exitFeatureWizard}
          setFeatureWizardStep={this.props.setFeatureWizardStep}
          currentGroup={currentGroup}
          isMobile={this.props.isMobile}
        />
      )
    }

    const values = this.props.searchText
      ? this.state.currentValues.filter((currentValue) => {
        const currentFilterValue = this.getFilterValueObjectById(currentGroup, currentValue.filterValue);
        return currentFilterValue && currentFilterValue.displayText.toLowerCase().includes(this.props.searchText.toLowerCase())
      })
      : this.state.currentValues;

    return this.props.isMobile ? (
      <div className="menu-body__content">
        <ul className={"menu-list menu-list--"+this.props.navigationViewType}>
          {values.map((wizardValueObject, filterValueIndex) => {
            const currentFilterValue = this.getFilterValueObjectById(currentGroup, wizardValueObject.filterValue);
            return this.getFeatureWizardBodyItem(
              currentFilterValue,
              currentGroup,
              wizardValueObject,
              filteredFeatures,
              fabricatorSettings,
              "item"+filterValueIndex
            )
          })}
        </ul>
      </div>
    ) : (
      <ul className={"categories-list categories-list--"+ this.props.navigationViewType}>
        {this.renderItemsList(currentGroup, filteredFeatures, values, fabricatorSettings)}
      </ul>
    )
  }
}

const mapStateToProps = (store) => ({
  fabricatorSettings: store.fabricatorState.settings,
  userIsLoggedIn: store.userState.userIsLoggedIn,
  navigationViewType: store.navigationState.navigationViewType
});

const mapDispatchToProps = () => ({});

export default connect(mapStateToProps, mapDispatchToProps)(FeatureWizardBody);
